import React, {useEffect} from 'react'
import {DropdownButton} from '@components/common/dropdown-list/dropdown-button'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {DateRangePicker, DateRange} from './date-picker'
import {useBoolean} from '@containers/hooks'
import {stringifyDatePart} from './util'

interface Props {
  initialDates: [Date, Date]
  onChoose: (range: [Date, Date]) => void
  onOpenChange?: (isOpen: boolean) => void
  disableFutureDates?: boolean
}

export const DateRangeInput = (props: Props) => {
  const {initialDates, onChoose, onOpenChange} = props
  const openState = useBoolean(false)
  const isOpen = openState.value
  useEffect(() => onOpenChange?.(isOpen), [isOpen])
  const value = {start: initialDates[0], end: initialDates[1]}

  return (
    <DropdownButton
      open={isOpen}
      onOpenChange={openState.setValue}
      content={
        <DropdownContent header="Свои даты">
          <DateRangePicker
            value={value}
            onChange={({start, end}) => onChoose([start, end])}
          />
        </DropdownContent>
      }
    >
      {formatRange(value)}
    </DropdownButton>
  )
}

const formatRange = ({start, end}: DateRange): string =>
  `${stringifyDatePart(start)}  — ${stringifyDatePart(end)}`
